module.exports = __webpack_public_path__ + "img/number-1.97ad15f4.png";